import { createStore } from '@/src/hooks/store/createStore';

interface VirtualMCVideoSources {
  opening?: string;
  milestones?: string[];
  challengeCompleted?: string;
  closing?: string;
}

interface VirtualMCSettingsState {
  videoSources: VirtualMCVideoSources;
  setVideoSources: (vs: VirtualMCVideoSources) => void;
  videoVisible: boolean;
  setVideoVisible: (b: boolean) => void;
  playingVideoSrc: string | null;
  setPlayingVideoSrc: (n: string | null) => void;
  videoAutoplay: boolean;
  setVideoAutoplay: (b: boolean) => void;
  audioEnabled: boolean;
  setAudioEnabled: (b: boolean) => void;
  reset: () => void;
}

export const useVirtualMCSettings = createStore<VirtualMCSettingsState>(null, (set, get, store) => ({
  videoSources: {},
  setVideoSources: (videoSources: VirtualMCVideoSources) => set({ videoSources }),
  videoVisible: false,
  setVideoVisible: (b) => set({ videoVisible: b }),
  playingVideoSrc: null,
  setPlayingVideoSrc: (playingVideoSrc) => set({ playingVideoSrc }),
  videoAutoplay: true,
  setVideoAutoplay: (b) => set({ videoAutoplay: b }),
  audioEnabled: true,
  setAudioEnabled: (b) => set({ audioEnabled: b }),
  reset: () => set(store.getInitialState()),
}));
